import { INSTRUCTOR_AWARD_DESCRIPTIONS, INSTRUCTOR_AWARD_ICON_URLS, INSTRUCTOR_AWARD_TITLES } from '../../constants/instructorConstants'
import { InstructorProfileData } from '../../server/types'

import './style.scss'

interface InstructorProfileAwardsProps {
	profileData: InstructorProfileData
}

function InstructorProfileAwards({profileData}: InstructorProfileAwardsProps) {

	// TODO: consider alternative method of accessing the enum with the string key
	const getAwardIconUrl = (award: string) => {
		let iconUrl = '' // TODO: Add a fallback icon url in case the given string can't be found in the enum
		for (let [key, value] of Object.entries(INSTRUCTOR_AWARD_ICON_URLS)) {
			if (key === award) {
				iconUrl = value
				break
			}
		}
		return iconUrl
	}

	const getAwardTitle = (award: string) => {
		let awardTitle = '' // TODO: Add a fallback icon url in case the given string can't be found in the enum
		for (let [key, value] of Object.entries(INSTRUCTOR_AWARD_TITLES)) {
			if (key === award) {
				awardTitle = value
				break
			}
		}
		return awardTitle
	}

	const getAwardDescription = (award: string) => {
		let awardDescription = '' // TODO: Add a fallback icon url in case the given string can't be found in the enum
		for (let [key, value] of Object.entries(INSTRUCTOR_AWARD_DESCRIPTIONS)) {
			if (key === award) {
				awardDescription = value
				break
			}
		}
		return awardDescription
	}

	return (
		<div className='section-content'>
			<div className='instructor-profile-awards-section'>
				<div className='instructor-profile-awards-section-title-wrap'>
					<img
						className="instructor-profile-awards-section-title-icon"
						src='/imgs/icons/awards/icon-awards.svg'
						alt={`Awards`}
					/>
					<span className='instructor-profile-awards-section-title'>
						Awards
					</span>
				</div>
				{profileData.awards?.split(',').map((award: string, index: number) => 
					<div
						className='instructor-profile-awards-award-wrap'
						key={`awardList${index}`}
					>
						<div className="instructor-profile-awards-award-icon-wrap">
							<img
								className="instructor-profile-awards-award-icon"
								src={getAwardIconUrl(award)}
								alt={`Awards`}
							/>
						</div>
						<div className='instructor-profile-awards-award-text-wrap'>
							<span className='instructor-profile-awards-award-title'>
								{getAwardTitle(award)}
							</span>
							<span className='instructor-profile-awards-award-description'>
								{getAwardDescription(award)}
							</span>
						</div>
					</div>
				)}
			</div>
		</div>
	)
}

export default InstructorProfileAwards

/*
instructor-profile-awards-section

instructor-profile-awards-section-title-wrap
instructor-profile-awards-section-title-icon 
instructor-profile-awards-section-title 

// AWARDS SECTION INDIVISUAL AWARD
instructor-profile-awards-award-wrap
instructor-profile-awards-award-icon
instructor-profile-awards-award-title
instructor-profile-awards-award-description
*/
